module.exports = __webpack_public_path__ + "assets/hardbrake.f361dbfa.svg";